<template>
  <Popover v-model:open="isFormOpen">
    <PopoverTrigger>
      <Button class="flex shrink-0 !px-3 !py-3 h-auto" variant="outline">
        <Icon
          height="20"
          width="20"
          class="flex shrink-0"
          icon="solar:chat-line-linear"
        ></Icon>
      </Button>
    </PopoverTrigger>
    <PopoverContent align="end" class="!w-[448px]">
      <div class="p-2">
        <div class="flex gap-x-7">
          <div>
            <h3 class="text-xl font-bold">
              {{ $t("listing.serveBetter", "How can we serve you better?") }}
            </h3>
            <p class="text-text-secondary text-sm mt-1.5">
              {{
                $t(
                  "listing.allEars",
                  "If you have any request/suggestions or if you are facing any issues, we are all ears.",
                )
              }}
            </p>
          </div>
          <Button class="p-2" variant="outline" @click="isFormOpen = false">
            <Icon
              height="20"
              width="20"
              icon="solar:alt-arrow-down-linear"
            ></Icon>
          </Button>
        </div>
        <div class="relative">
          <Skeleton
            v-if="isFormLoading"
            class="absolute top-0 z-20 h-full w-full background"
          ></Skeleton>
          <iframe
            ref="tallyIframe"
            data-tally-src="https://tally.so/embed/3qOlBO?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1"
            loading="lazy"
            width="100%"
            height="217"
            frameborder="0"
            marginheight="0"
            marginwidth="0"
            title="Prod Listing Form"
            @load="loaded"
          ></iframe>
        </div>
        <div class="mt-4 flex gap-y-4 w-full flex-col">
          <div
            class="w-52 flex gap-x-5 mx-auto items-center text-text-secondary"
          >
            <div class="border-t border-border-secondary w-full"></div>
            <div>{{ $t("or", "OR") }}</div>
            <div class="border-t border-border-secondary w-full"></div>
          </div>
          <div class="flex gap-x-2.5 mx-auto text-text-secondary">
            <div class="px-0.5 py-0.5">
              <a
                href="https://wa.me/+917248131247"
                target="_black"
                class="hover:text-accent-foreground transition-all"
              >
                <Icon icon="ri:whatsapp-line" height="20" />
              </a>
            </div>
            <div class="px-0.5 py-0.5">
              <a
                href="https://www.instagram.com/mockey.ai"
                target="_blank"
                class="hover:text-accent-foreground transition-all"
              >
                <Icon icon="ri:instagram-line" height="20" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </PopoverContent>
  </Popover>
</template>

<script setup lang="ts">
import { ref, watch, nextTick } from "vue";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { Icon } from "@iconify/vue";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";

const isFormOpen = ref(false);
const isFormLoading = ref(true);
const tallyIframe = ref(null);

const loaded = () => {
  const iframe = tallyIframe.value;
  if (iframe?.src) {
    isFormLoading.value = false;
  }
};

watch(isFormOpen, async (newVal) => {
  if (newVal) {
    isFormLoading.value = true;
    await nextTick();
    const iframe = tallyIframe.value;
    if (iframe) {
      iframe.src =
        "https://tally.so/embed/3qOlBO?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1";
    }
  }
});
</script>
